/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CostreportV1beta1ListIdleDisksResponse } from '../models';
/**
 * IdleResourcesAPIApi - axios parameter creator
 * @export
 */
export const IdleResourcesAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List idle disks in all connected clouds.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] Name of the field you want to sort
         * @param {IdleResourcesAPIListIdleDisksSortOrderEnum} [sortOrder] The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idleResourcesAPIListIdleDisks: async (pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: IdleResourcesAPIListIdleDisksSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/cost-reports/idle-resources/disks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IdleResourcesAPIApi - functional programming interface
 * @export
 */
export const IdleResourcesAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IdleResourcesAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List idle disks in all connected clouds.
         * @param {string} [pageLimit] 
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] Name of the field you want to sort
         * @param {IdleResourcesAPIListIdleDisksSortOrderEnum} [sortOrder] The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async idleResourcesAPIListIdleDisks(pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: IdleResourcesAPIListIdleDisksSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1ListIdleDisksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.idleResourcesAPIListIdleDisks(pageLimit, pageCursor, sortField, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdleResourcesAPIApi.idleResourcesAPIListIdleDisks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IdleResourcesAPIApi - factory interface
 * @export
 */
export const IdleResourcesAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IdleResourcesAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary List idle disks in all connected clouds.
         * @param {IdleResourcesAPIApiIdleResourcesAPIListIdleDisksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idleResourcesAPIListIdleDisks(requestParameters: IdleResourcesAPIApiIdleResourcesAPIListIdleDisksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1ListIdleDisksResponse> {
            return localVarFp.idleResourcesAPIListIdleDisks(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for idleResourcesAPIListIdleDisks operation in IdleResourcesAPIApi.
 * @export
 * @interface IdleResourcesAPIApiIdleResourcesAPIListIdleDisksRequest
 */
export interface IdleResourcesAPIApiIdleResourcesAPIListIdleDisksRequest {
    /**
     * 
     * @type {string}
     * @memberof IdleResourcesAPIApiIdleResourcesAPIListIdleDisks
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page. Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof IdleResourcesAPIApiIdleResourcesAPIListIdleDisks
     */
    readonly pageCursor?: string

    /**
     * Name of the field you want to sort
     * @type {string}
     * @memberof IdleResourcesAPIApiIdleResourcesAPIListIdleDisks
     */
    readonly sortField?: string

    /**
     * The sort order, possible values ASC or DESC, if not provided asc is the default   - ASC: ASC  - asc: desc  - DESC: ASC  - desc: desc
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof IdleResourcesAPIApiIdleResourcesAPIListIdleDisks
     */
    readonly sortOrder?: IdleResourcesAPIListIdleDisksSortOrderEnum
}

/**
 * IdleResourcesAPIApi - object-oriented interface
 * @export
 * @class IdleResourcesAPIApi
 * @extends {BaseAPI}
 */
export class IdleResourcesAPIApi extends BaseAPI {
    /**
     * 
     * @summary List idle disks in all connected clouds.
     * @param {IdleResourcesAPIApiIdleResourcesAPIListIdleDisksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdleResourcesAPIApi
     */
    public idleResourcesAPIListIdleDisks(requestParameters: IdleResourcesAPIApiIdleResourcesAPIListIdleDisksRequest = {}, options?: RawAxiosRequestConfig) {
        return IdleResourcesAPIApiFp(this.configuration).idleResourcesAPIListIdleDisks(requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const IdleResourcesAPIListIdleDisksSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type IdleResourcesAPIListIdleDisksSortOrderEnum = typeof IdleResourcesAPIListIdleDisksSortOrderEnum[keyof typeof IdleResourcesAPIListIdleDisksSortOrderEnum];
